import { api } from "@/builders/axios";
import { AdminUserList } from "@/builders/types/admin-user";
import { FilterParams } from "@/builders/types/filter-params";
import { USER_TYPE } from "@idss/libraries";

import { username } from "./username";

const get = function (
  params?: FilterParams<{
    user_type: USER_TYPE;
  }>
) {
  return api.get<AdminUserList>("/users", { params }).then(({ data }) => data);
};

const post = function (data: {
  username: string;
  first_name: string;
  last_name: string;
  other_names?: string;
  phone_number: string;
  email: string;
  role_ids?: Array<number>;
}) {
  return api.post("/users", data);
};

export const users = {
  get,
  post,
  username,
};
